<template>
    <div>
        <section class="breadcrumb-section embroidery_breadcrumb">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Design Template
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="embroidery_headings pb_50 pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box embroidery_sec_heading">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Design Template Gallery</span
                                >
                            </h1>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div
                        class="col-md-12 d-md-flex justify-content-center align-items-center embroidery_buttons"
                    >
                        <ul class="tab_one">
                            <li
                                :class="
                                    $route.path == '/design-templates'
                                        ? 'active'
                                        : ''
                                "
                            >
                                <a href="/design-templates"
                                    >Design Template Gallery</a
                                >
                            </li>
                            <li
                                :class="
                                    $route.path == '/screen-printing'
                                        ? 'active'
                                        : ''
                                "
                            >
                                <a href="/screen-printing"
                                    >Screen Print Gallery</a
                                >
                            </li>
                            <li
                                :class="
                                    $route.path == '/embroidery' ? 'active' : ''
                                "
                            >
                                <a href="/embroidery">Embroidery Gallery</a>
                            </li>
                        </ul>
                        <a
                            href="#"
                            class="btn btn_orange bg_primary_orange text_white ml-auto py_10 px_24"
                            >start Design Template</a
                        >
                    </div>
                </div>
            </div>
        </section>

        <section class="video_banner p-0">
            <div class="">
                <div class="col-md-12 p-0">
                    <img
                        src="/maincss/images/print_video_banner.png"
                        alt=" "
                        class="video_banner"
                    />
                    <div class="play_button">
                        <a href="#"
                            ><img
                                src="/maincss/images/play_icon.png"
                                alt=" "
                                class="w-auto play_image"
                        /></a>
                    </div>
                </div>
            </div>
        </section>

        <section class="embroidery_content">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_1.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_2.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_3.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_4.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>

                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_5.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_6.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_7.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_8.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>

                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_9.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_10.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_11.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                    <div class="col-md-4 col-6 col-lg-3">
                        <div class="embroidery_product position-relative mb_60">
                            <img
                                src="/maincss/images/print_product_12.png"
                                alt=" "
                                class="w-100"
                            />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <nav
                            aria-label="Page navigation example"
                            class="d-flex"
                        >
                            <ul class="pagination ml-auto mb-0">
                                <li class="page-item previous">
                                    <a class="page-link" href="#"
                                        ><img
                                            src="/maincss/images/previous_arrow.svg"
                                            alt=""
                                            class="mr_10"
                                        />
                                        Previous</a
                                    >
                                </li>
                                <li class="page-item active">
                                    <a class="page-link" href="#">1</a>
                                </li>
                                <li class="page-item">
                                    <a class="page-link" href="#">2</a>
                                </li>
                                <li class="page-item">
                                    <a class="page-link" href="#">3</a>
                                </li>
                                <li class="page-item next active">
                                    <a class="page-link" href="#"
                                        >Next
                                        <img
                                            src="/maincss/images/next_arrow.svg"
                                            alt=""
                                            class="ml_10"
                                    /></a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "DesignTemplates",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
    }
};
</script>
